module.exports = __webpack_public_path__ + "5c21c034ffc1c4a9dfec6a344f0a745a.png";